import { all, call, put, select, takeLatest } from "redux-saga/effects";
import {
  updateFilters,
  fetchSuccess,
  devicesCountSuccess,
  fetchFailure,
  devicesTypes,
  downloadSuccess,
  downloadFailure,
  fetchDeviceTypesSuccess,
  fetchDeviceTypesFailure,
  createSuccess,
  createFailure,
} from "../actions/devices";
import {
  fetchv1DeviceDetailsEndPoint,
  fetchLocationEndPoint,
  fetchOrganizationEndPoint,
  fetchDeviceTypesEndPoint,
  createAssetEndpoint,
  createDeviceEndpoint,
} from "../../configuration";
import { getRandomUUID } from "../../Token";
import { fectchOrgLocEndPoint } from "../../configuration";
import { JSONToCSVDownload } from "../../global/utility/jsonToCSVDownload";
import { calculateMacSerial } from "../../global/utility/macAddress";
import { notification } from "antd";

function* downloadSaga(action) {
  const filters = action.filter;
  const selectionFilters = alarmFilterbyfilters(filters);
  let body = {};
  if (selectionFilters.length > 0) {
    const filter = selectionFilters.join(" AND ");
    body = {
      accountName: sessionStorage.getItem("accountId"),
      filter:{
        $sort: filters.sort,
        $selection: `${filter}`,
      }
    };
  }
  try {
    const response = yield call(apiDownload, body);
    JSONToCSVDownload(
      deviceCSVFormat(response),
      `${action.payload}_download.csv`
    );
    yield put(downloadSuccess([...response]));
  } catch (error) {
    yield put(downloadFailure(error.message));
  }
}

function apiDownload(filter) {
  delete filter["$limitnumber"];
  delete filter["$pagenumber"];
  return fetch(fectchOrgLocEndPoint(), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    body: JSON.stringify(filter),
  }).then((response) => response.json());
}

const deviceCSVFormat = (jsonArray) => {
  if (!Array.isArray(jsonArray)) return [];

  return jsonArray.map((json) => ({
    name: json?.name,
    id: json?.id,
    creationDate: json?.createdon,
    lastUpdated: json?.lastupdated,
    serialNumber: "",
    healthStatus: json?.customdata?.healthStatus,
    connectionStatus: json?.customdata?.connectionStatus,
    activeStatus: json?.customdata?.activeStatus,
    mainDashboardId: "",
    status: json?.status,
    DeviceRecipe: json?.customdata?.deviceType,
    major: "",
    minor: "",
    uid: json?.uid,
    uidHex: "",
    deviceType: json?.customdata?.deviceType,
    assetType: json?.customdata?.assetType,
    organizationId: json?.customdata?.orgId,
    locationId: json?.customdata?.locId,
    organizationName: json?.customdata?.shipmentname,
    locationName: json?.customdata?.locationName,
    lastKnownGps:
      json.fields?.location?.type === "gps"
        ? `${json.fields?.location?.latitude}, ${json.fields?.location?.longitude}`
        : "",
    locationArrivalTime: json?.customdata?.arrivedLocationTimestamp,
    lostStatus: "",
    idleStatus: json?.customdata?.healthStatus,
    lifeCycleStatus: json?.customdata?.lifeCycleStatus,
    productiveStatus: json?.customdata?.productiveStatus,
    lastLocationId: "",
    lastLocationName: "",
    lastReportedAt: "",
  }));
};

function* fetchDevicesSaga(action) {
  const filters = action.payload;
  const healthStatusMaster = yield select(
    (state) => state.devices.data.healthStatusList
  );
  const connStatusMaster = yield select(
    (state) => state.devices.data.deviceConnectedStatusList
  );
  try {
    yield put(updateFilters(filters));

    const response = yield call(fetchDeviceAPI, filters);
    const allDevices   = response.devices ?? [];
    const totalCount   = response.totalCount ?? allDevices.length;
    const counts = {
      total:        totalCount,
      online:       response["Online Devices"]      ?? 0,
      offline:      response["Offline Devices"]     ?? 0,
      warning:      response["Warning Devices"]     ?? 0,
      notification: response["Notification"]        ?? 0,
      error:        response["Critical Devices"]    ?? 0,
      ok:           response["Ok"]                  ?? 0,
    };

    const healthStatusList = healthStatusMaster.map((h) => ({
      ...h,
      value:
        (filters.healthStatus || []).includes(h.label),
    }));

    const deviceConnectedStatusList = connStatusMaster.map((d) => ({
      ...d,
      value:
        (filters.deviceConnectedStatus || []).includes(d.label),
    }));

    yield put(
      fetchSuccess({
        devices: allDevices,
        healthStatusList,
        deviceConnectedStatusList,
      })
    );

    yield put(devicesCountSuccess(counts));
  } catch (error) {
    yield put(fetchFailure(error.message));
  }
}
export function* createDeviceSaga() {
  try {
    const { formData, createdby } = yield select((state) => ({
      formData: state.devices.ui.formData,
      createdby: state.auth?.user?.userName || "",
    }));
    let newForm = {};
    const isBTM = formData?.deviceType?.toUpperCase().startsWith("BTM");
    const isMocoSmart = formData?.deviceType?.toUpperCase().startsWith("MOCO SMART - N2");
    if (isBTM) {
      newForm = {
        devicetype: formData?.deviceType,
      major: formData?.major,
      minor: formData?.minor,
      createdby,
    }
  } else if (isMocoSmart) {
      newForm = {
        devicetype: formData?.deviceType,
        uniqueidentifier: calculateMacSerial(formData?.macAddress),
        mac: formData?.macAddress,
        createdby,
      };
  } else {
      newForm = {
        devicetype: formData?.deviceType,
        uniqueidentifier: formData?.serialNumber,
        createdby,
      };
  }
    const newDevice = yield call(createDeviceAPI, newForm);
    yield put(createSuccess(newDevice));
  } catch (error) {
    yield put(createFailure(error.message));
  }
}
async function createDeviceAPI(formData) {
  const response = await fetch(createDeviceEndpoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      ...formData,
    }),
  });

  if (!response.ok) throw new Error("Something Went wrong");
  const result = await response.json();

  return result;
}
function alarmFilterbyfilters(filters) {
  let selectionFilters = [];
  if (filters.healthStatus !== null && filters.healthStatus !== "" && filters.healthStatus?.length>0) {
    let query = [];
    for (let i = 0; i < filters.healthStatus.length; i++) {
      switch (filters.healthStatus[i]) {
        case "Ok":
          query.push(`($/customdata/healthStatus eq 'OK')`);
          break;
        case "Warning":
          query.push(`($/customdata/healthStatus eq 'WARNING') OR ($/customdata/healthStatus eq 'MAJOR')`);
          break;
        case "Error":
          query.push(
            `($/customdata/healthStatus eq 'ERROR') OR ($/customdata/healthStatus eq 'CRITICAL')`
          );
          break;
        case "Critical":
          query.push(
            `($/customdata/healthStatus eq 'ERROR') OR ($/customdata/healthStatus eq 'CRITICAL')`
          );
          break;
        case "Unknown":
          query.push(`($/customdata/healthStatus eq 'UNKNOWN')`);
          break;
        case "Notification":
          query.push(
            `($/customdata/healthStatus eq 'NOTIFICATION') OR ($/customdata/healthStatus eq 'MINOR')`
          );
          break;
        default:
          break;
      }
    }
    if (query.length > 0) {
      selectionFilters.push(`(${query.join(" OR ")})`);
    }
  }

  if (
    filters.deviceConnectedStatus !== null &&
    filters.deviceConnectedStatus !== "" && filters.deviceConnectedStatus?.length>0
  ) {
    let query = [];
    for (let i = 0; i < filters.deviceConnectedStatus.length; i++) {
      switch (filters.deviceConnectedStatus[i]) {
        case "Online":
          query.push(`($/customdata/connectionStatus eq 'ONLINE')`);
          break;
        case "Offline":
          query.push(`($/customdata/connectionStatus eq 'OFFLINE')`);
          break;
        case "Unknown":
          query.push(`($/customdata/connectionStatus eq 'UNKNOWN')`);
        default:
          break;
      }
    }
    if (query.length > 0) {
      selectionFilters.push(`(${query.join(" OR ")})`);
    }
  }

  if (filters.deviceName) {
    selectionFilters.push(`(name LIKE '%${filters.deviceName}%')`);
  }

  if (
    filters.activeStatus !== null &&
    filters.activeStatus !== "" &&
    filters.activeStatus.length > 0 &&
    !filters.activeStatus.includes("")
  ) {
    let query = [];
    for (let i = 0; i < filters.activeStatus.length; i++) {
      query.push(`($/customdata/activeStatus eq '${filters.activeStatus[i]}')`);
    }
    if (query.length > 0) {
      selectionFilters.push(`(${query.join(" OR ")})`);
    }
  }
  if (
    filters.deviceType !== null &&
    filters.deviceType !== "" &&
    filters.deviceType.length > 0 &&
    !filters.deviceType.includes("")
  ) {
    let query = [];
    let andQuery = '';
console.log('filters.deviceType',filters.deviceType);
    for (let devType of filters.deviceType) {
      if (devType === "ts.device.tgAssetTracker") {
        query.push(`(kind eq '${devType}')`);
        query.push(`(kind eq 'ts.device.cHeAssetTracker')`);
      } else if (devType === "AssetTracker") {
        query.push(`(kind LIKE '%AssetTracker%')`);
        if(filters.isAvailable){
          andQuery = `($/customdata/isAvailable eq true)`;
        }
      } else {
        query.push(`(kind eq '${devType}')`);
      }
    }

    if (query.length > 0) {
      selectionFilters.push(`(${query.join(" OR ")} ${andQuery!==''?' AND '+andQuery:''})`);
    }
  }

  if (filters.organization !== null && filters.organization !== "") {
    let query = [];
    for (let i = 0; i < filters.organization.length; i++) {
      query.push(
        `($/customdata/organizationName eq '${filters.organization[i]}')`
      );
    }
    if (query.length > 0) {
      selectionFilters.push(query.join(" OR "));
    }
  }
  if (filters.location !== null && filters.location !== "") {
    let query = [];
    for (let i = 0; i < filters.location.length; i++) {
      query.push(`($/customdata/locationName eq '${filters.location[i]}')`);
    }
    if (query.length > 0) {
      selectionFilters.push(query.join(" OR "));
    }
  }

  if (filters.associationname) {
    const associationnameQuery = `($/customdata/shipmentname LIKE '${filters.associationname}' OR $/customdata/assetname LIKE '${filters.associationname}')`;
    selectionFilters.push(associationnameQuery);
  }

  return selectionFilters;
}
function* fetchDeviceTypesSaga() {
  try {
    let deviceTypes = yield call(fetchDeviceTypesAPI);
    if (
      Array.isArray(deviceTypes?.devicetypes) &&
      deviceTypes?.devicetypes?.length > 0
    ) {
      deviceTypes = deviceTypes?.devicetypes.filter(
        (type) => type?.devicemodel?.toLowerCase() === "ble"
      );
    }

    yield put(fetchDeviceTypesSuccess(deviceTypes));
  } catch (error) {
    yield put(fetchDeviceTypesFailure(error.message));
  }
}
async function fetchDeviceTypesAPI() {
  const response = await fetch(fetchDeviceTypesEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({ accountName: sessionStorage.getItem("accountId") }),
  });

  if (!response.ok) throw new Error("Something Went wrong");
  const result = await response.json();

  return result;
}
async function fetchDeviceAPI(filters) {
  let body = {
    accountName: sessionStorage.getItem("accountId"),
  };
  let selection = '';
  const selectionFilters = alarmFilterbyfilters(filters);

  if (selectionFilters.length > 0) {
    selection = selectionFilters.join(" AND ");
  }

  body.filter = {
    $sort: filters.sort,
    $limitnumber: filters.limitnumber,
    $pagenumber: filters.pagenumber,
    $selection: `${selection}`,
  }

  const response = await fetch(fetchv1DeviceDetailsEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify(body),
  });
  if (!response.ok) throw new Error("Something Went wrong");
  return response.json();
}

async function fetchOrganizationAPI() {
  const locResponse = await fetchLocationAPI();
  const response = await fetch(fetchOrganizationEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      filter: { $sort: [{ field: "createdon", order: "desc" }] },
    }),
  });

  if (!response.ok) throw new Error("Something Went wrong");
  const orgs = await response.json();
  const countMap = {};

  locResponse.forEach((siteItem) => {
    const orgId = siteItem.tags?.[0]?.orgId;
    if (orgId) {
      countMap[orgId] = (countMap[orgId] || 0) + 1;
    }
  });

  orgs.forEach((orgItem) => {
    const orgId = orgItem.id;
    const count = countMap[orgId] || 0;
    orgItem.locationcount = (orgItem.count || 0) + count;
  });

  return orgs;
}

async function fetchLocationAPI() {
  const response = await fetch(fetchLocationEndPoint(), {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + sessionStorage.getItem("bearer_token"),
      "VZ-M2M-Token": getRandomUUID(),
    },
    method: "POST",
    body: JSON.stringify({
      accountName: sessionStorage.getItem("accountId"),
      filter: { $sort: [{ field: "createdon", order: "desc" }] },
    }),
  });

  if (!response.ok) throw new Error("Something Went wrong");
  return response.json();
}

export function* DevicesSaga() {
  yield takeLatest(devicesTypes.FETCH_REQUEST, fetchDevicesSaga);
}
export function* DeviceDownloadSaga() {
  yield takeLatest(devicesTypes.DOWNLOAD_REQUEST, downloadSaga);
}
export function* FetchDevicesTypesSaga() {
  yield takeLatest(devicesTypes.FETCH_DEVICE_TYPES_REQUEST, fetchDeviceTypesSaga);
}
export function* CreateDeviceSaga() {
  yield takeLatest(devicesTypes.CREATE_REQUEST, createDeviceSaga);
}